/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {ResolvedIssues} from '../../core/_models'

type Props = {
  resolved_issues: ResolvedIssues
}

const ResolvedIssuesInfoCell: FC<Props> = ({resolved_issues}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span className='text-gray-800 mb-1 h6'>
          {resolved_issues.activity_description && resolved_issues.activity_description?.length > 20
            ? resolved_issues.activity_description?.substring(0, 20) + '...'
            : resolved_issues.activity_description}
        </span>
        <span className='text-muted'>
          {resolved_issues.activity_environment} - {resolved_issues.activity_frequency}
        </span>
      </div>
    </div>
  )
}

export {ResolvedIssuesInfoCell}
